<script>

    import DateMethods from '../$methods/date.methods'

    export let value = null

</script>

<style>
    .muted { font-size: 0.8rem; color: #9e9e9e; }
    .time { color: #9e9e9e; }
</style>

{#if value}
    <div>{ DateMethods.dateLarge(value) }</div>
    <div class="time is-size-7">{ DateMethods.hourLarge(value) }</div>
{:else}
    <span class="muted">—</span>
{/if}
